module.exports = __webpack_public_path__ + "img/grp-part-3-review-1.8c6cd350.png";